import cloneDeep from 'lodash/cloneDeep';
import { useState, useEffect } from 'react';

const useFieldSchemaUpdate = ({ form, schema, }) => {
    const { parentField, onParentChange } = schema;
    const isDependOnParent = parentField && !!onParentChange;
    const [newSchema, setNewSchema] = useState(schema);
    const watchedParent = isDependOnParent ? form.watchValues(parentField) : undefined;
    useEffect(() => {
        if (schema.onParentChange && schema.parentField) {
            const newSchemaState = schema.onParentChange(watchedParent, cloneDeep(schema), form);
            setNewSchema(newSchemaState);
        }
    }, [watchedParent]);
    return isDependOnParent ? newSchema : schema;
};

export { useFieldSchemaUpdate };
